const initState =
{
  layers          : true,
  location        : null,
  center          : ['-0.195350', '-78.491478'],
  zoom            : 12,
}

const mapReducer = (state = initState, action) =>
{
  switch (action.type)
  {
    case 'SET_LAYERS':
      return {
        ...state,
        layers: action.layers
      };

    case 'SET_LOCATION':
      return {
        ...state,
        location: action.location
      };

    case 'SET_CENTER':
      return {
        ...state,
        center: action.center
      };

    case 'SET_ZOOM':
      return {
        ...state,
        zoom: action.zoom
      }; 

    default:
      return state; 
  }
}

export default mapReducer;